import store from '@/store';

const saveEvent = payload => {
	store.dispatch('app/saveAnalytic', {
        event: payload.event,
        params: payload.params
    })
};

export { saveEvent };